import jsQR from 'jsqr';

export interface QRDecodeResult {
  success: boolean;
  data?: string;
  error?: string;
}

/**
 * Decode QR code from image URL (supports base64, data URL, blob URL, web path)
 */
export async function decodeQRFromImage(imageUrl: string): Promise<QRDecodeResult> {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      try {
        // Create canvas and draw image
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          resolve({ success: false, error: 'ไม่สามารถสร้าง Canvas ได้' });
          return;
        }
        
        // Set canvas size to image size
        canvas.width = img.width;
        canvas.height = img.height;
        
        // Draw image to canvas
        ctx.drawImage(img, 0, 0);
        
        // Get image data
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        
        // Decode QR using jsQR
        const qrCode = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert',
        });
        
        if (qrCode) {
          resolve({ success: true, data: qrCode.data });
        } else {
          // Try with inverted colors
          const invertedResult = jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: 'attemptBoth',
          });
          
          if (invertedResult) {
            resolve({ success: true, data: invertedResult.data });
          } else {
            resolve({ success: false, error: 'ไม่พบ QR Code ในรูปภาพ' });
          }
        }
      } catch (error) {
        console.error('QR decode error:', error);
        resolve({ success: false, error: 'เกิดข้อผิดพลาดในการอ่าน QR Code' });
      }
    };
    
    img.onerror = () => {
      resolve({ success: false, error: 'ไม่สามารถโหลดรูปภาพได้' });
    };
    
    // Set image source
    img.src = imageUrl;
  });
}

/**
 * Convert File to data URL for processing
 */
export function fileToDataURL(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
